import React from 'react';

const Topics = () => {
  return (
    <div className="page-container">
      <h1>Topics... Comming Soon...</h1>
      {/* <p>This is the Topics page content.</p> */}
    </div>
  );
};

export default Topics;
